import script from "./OuterHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./OuterHeader.vue?vue&type=script&setup=true&lang=ts"

import "./OuterHeader.vue?vue&type=style&index=0&id=d19525e2&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/livoapp/LivoFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d19525e2"]])

export default __exports__